<template>
    <div class="container">
        <md-dialog :md-active.sync="modCrearMoneda" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <md-dialog-content>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.moneda}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <select id="" v-model="moneda" class="form-control">
                            <option value="">{{ labels.select }}</option>
                            <option v-for="tipMoneda in lstTipoMoneda" :key="tipMoneda.id" :value="tipMoneda.moneda">{{ tipMoneda.descripcion }}</option>
                        </select>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.vigencia}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="date" v-model="vigencia" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.trm}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="trm" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.trmPromedio}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="trmPromedio" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.valorPropio}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="valorPropio" class="form-control">
                    </b-col>
                </b-row>
                <md-dialog-actions class="mt-3">
                    <md-button class="md-primary" @click="guardarMoneda">{{ labels.save }}</md-button>
                    <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>
import TipoMoneda from '../../../services/TipoMoneda';
import Moneda from '../../../services/Moneda';

export default {
    name : 'Crear',
    props: ['modCrearMoneda'],
    data: () => ({
        moneda : '',
        vigencia : '',
        trm : null,
        trmPromedio : null,
        valorPropio : null,
        lstTipoMoneda : []
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Crear moneda',
                    save : 'Guardar',
                    close : 'Cerrar',
                    select : 'Seleccione...',
                    moneda : 'Moneda',
                    vigencia : 'Vigencia',
                    trm : 'TRM',
                    trmPromedio : 'TRM promedio',
                    valorPropio : 'Valor propio'
                }
            }else{
                return {
                    title : 'Create currency',
                    save : 'Save',
                    close : 'Close',
                    select : 'Select...',
                    moneda : 'Currency',
                    vigencia : 'Validity',
                    trm : 'TRM',
                    trmPromedio : 'Average trm',
                    valorPropio : 'Self value'
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        guardarMoneda(){
            const dataForm = [
                this.moneda,
                this.vigencia,
                this.trm,
                this.trmPromedio,
                this.valorPropio
            ]

            if(dataForm.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            }else{

                let info = {
                    'moneda' : this.moneda,
                    'vigencia' : this.vigencia,
                    'trm' : this.trm,
                    'trmPromedio' : this.trmPromedio,
                    'valorPropio' : this.valorPropio,
                    'idUser' : this.$store.state.userId
                }

                Moneda.createMoneda(info)
                .then((res) => {
                    if(res.status == 201){
                        this.$toast.success(res.data.message)
                        location. reload()                    
                    }
                })
                .catch((error) => console.log(error))
            }
        }
    },
    mounted(){
        TipoMoneda.getAllTipoMoneda()
        .then((res) => {
            // console.log(res.data);
            this.lstTipoMoneda = res.data.listTipoMoneda
        })
        .catch((err) => console.log(err))
    }
}
</script>

<style>

</style>